import useOutsideClick from "hooks/useOutSideClick";
import SelectFormulaDropdown from "./SelectFormulaDropdown";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { v4 } from "uuid";
import { FormulaTree } from "utils/services";
import { isNumeric } from "utils/helpers";

const SelectFormulaInput = ({
  onSelectItem,
  dropdownData,
  setActive,
  initValue = "",
  initShowDropdown,
  refLink,
}) => {
  const [searchValue, setSearchValue] = useState(initValue);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    setShowDropdown(initShowDropdown);
  }, [initShowDropdown]);

  useOutsideClick(refLink, () => {
    closeDropdown();
  });

  const openDropdown = () => {
    setShowDropdown(true);
  };

  const closeDropdown = () => {
    setShowDropdown(false);
    setActive(false);
  };

  const onChangeHandler = (event) => {
    setSearchValue(event.currentTarget.value);
  };

  const onEnterHandler = (event) => {
    if (event.keyCode === 13 && event.code === "Enter") {
      const isValidNumber = isNumeric(searchValue);
      if (isValidNumber) {
        onSelectItem({
          key: v4(),
          name: searchValue,
          label: `${searchValue}`,
          valueType: "number",
          nextNodeType: [FormulaTree.NODE_TYPES.Operator],
          type: FormulaTree.NODE_TYPES.Value,
        });
      }
    }
  };

  const currentInputPosition = refLink.current
    ? refLink.current.getBoundingClientRect()
    : {};

  return (
    <div>
      <input
        value={searchValue}
        className={"select_function_input select_function_input--active"}
        autoFocus
        style={{ width: `${searchValue.length + 2}ch` }}
        onClick={openDropdown}
        onKeyDown={onEnterHandler}
        onChange={onChangeHandler}
      />
      {showDropdown && (
        <SelectFormulaDropdown
          onSelectItem={onSelectItem}
          searchValue={searchValue}
          currentInputPosition={currentInputPosition}
          dropdownData={dropdownData}
          closeDropdown={closeDropdown}
        />
      )}
    </div>
  );
};

export default SelectFormulaInput;
